<template>
    <div class="shopMain">
        <BuyNowButton v-if="false && shopInfo && shopInfo.specificationId != 0" :shopInfo="shopInfo ? shopInfo : {}" />

        <div>
            <BaseFullScreenAnimation ref="baseFullScreenAnimation"/>
        </div>
        <div class="header">
            <HeaderAddress :shopId="shopId">
                <div class="searchIconWrapper">
                    <SearchIcon @click.native.stop="$router.push({ path: `/shopSearch?shopId=${shopId}` })" />
                </div>
            </HeaderAddress>
        </div>

        <div class="contentWrapper" v-swipe-up="swipeUp" v-swipe-down="swipeDown">
            <div ref="topContent" class="topContent">
                <div class="warningAndshopDescription" ref="warningAndshopDescription">
                    <!-- warning -->
                    <template v-if="ifShowHeaderWarning">
                        <div class="headerWarning">不支持配送到当前地址</div>
                        <div class="horizonGully" />
                    </template>
                    
                    <!-- shop description -->
                    <BriefShopInfo />
                </div>

                <van-swipe :autoplay="3000" v-if="shopInfo" style="flex-shrink: 0;">
                    <van-swipe-item
                        v-for="(item, index) in shopInfo.shopBroadcastPictures"
                        :key="index"
                    >
                        <img
                            loading="lazy"
                            :src="getImgUrl(item.picture[0])"
                            @click="urlLocate(item.url)"
                            style="
                                width: 100%;
                                height: calc(100vw * 246 / 750);
                            "
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>

            <!-- content tab -->
            <div class="compositionContentTab" ref="compositionContentTab">
                <div
                    style="
                        width: 100%;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-around;
                    "
                >
                    <div
                        @click="
                            clickActiveCompositionContentTab(
                                'productAll',
                                true
                            )
                        "
                    >
                        全部商品
                    </div>
                    <div
                        v-if="false"
                        @click="
                            clickActiveCompositionContentTab(
                                'productCategory',
                                true
                            )
                        "
                    >
                        商品分类
                    </div>
                    <div
                        @click="
                            clickActiveCompositionContentTab(
                                'comment',
                                true
                            )
                        "
                    >
                        <div style="display: flex; align-items: center">
                            <span>评价</span>
                            <span
                                >{{
                                    lodash.round(shopInfo.scoring, 1)
                                }}</span
                            >
                        </div>
                    </div>
                    <div
                        @click="
                            clickActiveCompositionContentTab('shop', true)
                        "
                    >
                        商家
                    </div>
                </div>
                <div class="horizonGully" />
                <div
                    class="stickyCompositionContentTabBottomLine"
                    ref="stickyCompositionContentTabBottomLine"
                ></div>
            </div>

            <div class="horizonGully" style="flex-shrink:0;" />

            <!-- content -->
            <div
                class="contentCompositionWrapper"
                ref="contentCompositionWrapper"
            >
                <!-- 全部商品 -->
                <BaseFadeTransition :ifCrossFade="true">
                    <div
                        class="contentCompositionProductAllWrapper"
                        v-show="activeCompositionContentTab == 'productAll'"
                    >
                        <BaseScroll
                            :ifScrollHorizon="true"
                            :showLoading="false"
                            class="categoryItemList"
                            ref="contentCompositionProductAllTypeScroll"
                            @scrollTop="productListAllTypeScrollTop"
                        >
                            <div :class="{
                                'categoryItemActive': ifShowAllProductList,
                                'categoryItem': !ifShowAllProductList,
                            }" @click="showAllProduct" ref="productAllSideType_all">
                                <div class="title">所有商品</div>
                                <div class="number">{{ productPurchaseTotalNumber }}</div>
                            </div>

                            <div
                                @click.capture.stop="
                                    clickProductTypeSidebar(index)
                                "
                                v-for="(item, index) of category"
                                :key="'category' + index"
                                :class="{
                                    'categoryItemActive': ifShowAllProductList == false && activeProductTypeIndex == index,
                                    'categoryItem': ifShowAllProductList == true || activeProductTypeIndex != index,
                                }"
                                :ref="`productAllSideType_${index}`"
                            >
                                <div class="title">{{ item.productTypeName }}</div>
                                <div class="number">
                                    {{ productTypeStatistic[
                                        item.productTypeId
                                        ]
                                        ? productTypeStatistic[
                                            item.productTypeId
                                        ]
                                        : '' }}
                                </div>
                            </div>

                            <div class="productAllTypeBottomLine" ref="productAllTypeBottomLine" />
                        </BaseScroll>

                        <BaseScroll
                            ref="contentCompositionProductAllScroll"
                            style="width: 100%; height: 100%;overflow-y: auto;flex-grow: 1;"
                            @scrollTop="productListAllScrollTop"
                            :showLoading="false"
                            v-swipe-left="productAllSwipeLeft" v-swipe-right="productAllSwipeRight"
                        >
                            <div>
                                <div
                                    :class="{
                                        'productOfProductAllLeft': index % 2 == 0,
                                        'productOfProductAllRight': index % 2 != 0,
                                    }"
                                    v-for="(
                                        {
                                            pId,
                                            priceType,
                                            pName,
                                            pPic1,
                                            pNowPrice,
                                            pOriginalPrice,
                                            distance,
                                            transportationMode,
                                            transportationDescriptionList,
                                            specificationList,
                                            shelfIdList,
                                        },
                                        index
                                    ) of productListWithTagAll"
                                    :key="`productAll_${ifShowAllProductList ? 'all' : activeProductTypeIndex}_${pId}`"
                                    @click="goToProductDetail(shopId, pId)"
                                >
                                    <ProductOfListBrief
                                        :shopId="shopId"
                                        :productId="
                                            pId
                                        "
                                        :distance="distance"
                                        :transportationMode="
                                            transportationMode
                                        "
                                        :transportationDescriptionList="
                                            transportationDescriptionList
                                        "
                                        :priceType="priceType"
                                        :productName="pName"
                                        :productImg="pPic1"
                                        :productPrice="pNowPrice"
                                        :productOriginalPrice="
                                            specificationList.length > 1 ? -1 : pOriginalPrice
                                        "
                                        :specificationList="
                                            specificationList
                                        "
                                    />
                                </div>
                            </div>
                        </BaseScroll>
                    </div>
                </BaseFadeTransition>

                <!-- 商品分类 -->
                <template v-if="false">
                    <BaseFadeTransition :ifCrossFade="true">
                        <div
                            class="contentCompositionProductCategoryWrapper"
                            v-show="
                                activeCompositionContentTab == 'productCategory'
                            "
                        >
                            <!-- 商品分类 -->
                            <BaseScroll
                                ref="contentCompositionProductTypeScroll"
                                class="contentCompositionProductTypeScroll"
                                @scrollTop="productCategoryScrollTop"
                                :showLoading="false"
                            >
                                <div ref="contentCompositionProductTypeContent">
                                    <van-sidebar
                                        v-model="activeProductTypeIndex"
                                        ref="contentCompositionProductType"
                                    >
                                        <div
                                            @click.capture.stop="
                                                clickProductTypeSidebar(index)
                                            "
                                            v-for="(item, index) of category"
                                            :key="'category' + index"
                                        >
                                            <van-sidebar-item
                                                :title="item.productTypeName"
                                                :badge="
                                                    productTypeStatistic[
                                                        item.productTypeId
                                                    ]
                                                        ? productTypeStatistic[
                                                            item.productTypeId
                                                        ]
                                                        : ''
                                                "
                                            />
                                        </div>
                                    </van-sidebar>
                                </div>
                            </BaseScroll>

                            <!-- 商品列表 -->
                            <BaseScroll
                                ref="contentCompositionProductListScroll"
                                class="
                                    contentCompositionProductListScroll
                                "
                                @scrollTop="productListScrollTop"
                                :showLoading="false"
                            >
                                <div>
                                    <!-- 刚刚看过 -->
                                    <div v-if="interestedProductInfo">
                                        <ProductOfShop
                                            @click.native="goToProductDetail(shopId, interestedProductInfo.pId)"
                                            style="background: #ffffff"
                                            :key="
                                                'interestedProductInfo_' +
                                                interestedProductInfo.pId
                                            "
                                            :shopId="shopId"
                                            :productId="
                                                interestedProductInfo.pId
                                            "
                                            :productName="
                                                interestedProductInfo.pName
                                            "
                                            :productNowPrice="
                                                parseFloat(
                                                    interestedProductInfo.pNowPrice.toFixed(
                                                        2
                                                    )
                                                )
                                            "
                                            :productOriginalPrice="
                                                parseFloat(
                                                    interestedProductInfo.pOriginalPrice.toFixed(
                                                        2
                                                    )
                                                )
                                            "
                                            :productNumOfSold="
                                                parseInt(
                                                    interestedProductInfo.pNumOfBuy
                                                )
                                            "
                                            :productImg="
                                                interestedProductInfo.pPic_1
                                            "
                                            :specificationList="
                                                interestedProductInfo.specificationList
                                            "
                                            :shelfId="
                                                interestedProductInfo.shelfId
                                            "
                                        />
                                        <div class="horizonGully" />
                                    </div>

                                    <!-- 商品 -->
                                    <div
                                        v-for="(
                                            {
                                                pId,
                                                pName,
                                                pNowPrice,
                                                pOriginalPrice,
                                                pNumOfBuy,
                                                pPic1,
                                                specificationList,
                                                shelfIdList,
                                                currentCategory,
                                            },
                                            index
                                        ) of productListNeedShowWithCagetoryId"
                                        :key="`ProductOfShop-${pId}-${currentCategory}`"
                                        :ref="`ProductOfShop-${pId}-${currentCategory}`"
                                        :id="`productOfShopIndex_${index}`"
                                    >
                                        <ProductOfShop
                                            @click.native="goToProductDetail(shopId, pId)"
                                            style="
                                                width: 100%;
                                                background: #ffffff;
                                            "
                                            :shopId="shopId"
                                            :productId="pId"
                                            :productName="pName"
                                            :productNowPrice="
                                                parseFloat(pNowPrice.toFixed(2))
                                            "
                                            :productOriginalPrice="
                                                parseFloat(
                                                    pOriginalPrice.toFixed(2)
                                                )
                                            "
                                            :productNumOfSold="
                                                parseInt(pNumOfBuy)
                                            "
                                            :productImg="pPic1"
                                            :specificationList="
                                                specificationList
                                            "
                                            :shelfId="shelfIdList"
                                        />

                                        <!-- 高度莫随意修改, productListScrollTop需要使用 -->
                                        <div style="height: 10px" />
                                    </div>
                                </div>
                                <div
                                    ref="contentCompositionProductListPadding"
                                    style="height: 0px"
                                />
                            </BaseScroll>
                        </div>
                    </BaseFadeTransition>
                </template>
                <BaseFadeTransition :ifCrossFade="true">
                    <div
                        class="contentCompositionCommentWrapper"
                        v-show="activeCompositionContentTab == 'comment'"
                    >
                        <BaseScroll
                            ref="contentCompositionCommentListScroll"
                            style="width: 100%; height: 100%;"
                            @pullingUp="commentListPullingUp"
                        >
                            <div
                                ref="contentCompositionCommentListContent"
                                style="width: 100%; height: 100%;"
                            >
                                <template
                                    v-if="commentList.records.length > 0"
                                >
                                    <div
                                        v-for="(
                                            {
                                                user,
                                                evaluationUserPetName,
                                                evaluationOfGoodsTime,
                                                evaluationOfGoodsMsg,
                                                productName,
                                            },
                                            index
                                        ) of commentList.records"
                                        :key="'comment' + index"
                                        style="
                                            box-sizing: border-box;
                                            padding: 10px;
                                        "
                                    >
                                        <Comment
                                            :wxAvatar="
                                                user ? user.wxAvatar : null
                                            "
                                            :evaluationUserPetName="
                                                evaluationUserPetName
                                            "
                                            :evaluationOfGoodsTime="
                                                evaluationOfGoodsTime
                                            "
                                            :evaluationOfGoodsMsg="
                                                evaluationOfGoodsMsg
                                            "
                                            :productName="productName"
                                        />
                                        <div
                                            v-show="
                                                index !==
                                                commentList.records.length -
                                                    1
                                            "
                                        >
                                            <div class="horizonDivider" />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div
                                        class="
                                            commentNoData
                                        "
                                    >
                                        暂无数据
                                    </div>
                                </template>
                            </div>
                        </BaseScroll>
                    </div>
                </BaseFadeTransition>

                <BaseFadeTransition :ifCrossFade="true">
                    <div
                        class="contentCompositionShopWrapper"
                        style="overflow-y: auto;-webkit-overflow-scrolling: touch;"
                        v-if="activeCompositionContentTab == 'shop'"
                    >
                        <ShopInfo
                            ref="shopInfo"
                            :shopName="shopInfoDetail.shopName"
                            :shopMobile="shopInfoDetail.linkMobilePhone"
                            :shopAddress="shopInfoDetail.address"
                            :shopPositionLongitude="
                                shopInfoDetail.longitude
                            "
                            :shopPositionLatitude="shopInfoDetail.latitude"
                            :shopCertificateImg="
                                shopInfoDetail.businessLicense
                            "
                            :shopFoodCertificateImg="shopInfoDetail.img"
                        />
                    </div>
                </BaseFadeTransition>
            </div>
        </div>

        <!-- bottom -->
        <div class="bottomBar">
            <div
                class="
                  autoHorizonScroll  
                "
            >
                <BaseAutoHorizonScroll :text="bottomBarDescription" />
            </div>

            <div class="operatePanel">
                <div class="homeIconWrapper" @click="goToMainPage">
                    <i class="iconfont icon-home" />
                    <div class="label">首页</div>
                </div>

                <div class="mineIconWrapper" @click="goToMine">
                    <i class="iconfont icon-mine" />
                    <div class="label">我的</div>
                </div>

                <div class="mineIconWrapper" @click="contactCustomerService">
                    <i class="iconfont icon-mine" />
                    <div class="label">客服</div>
                </div>

                <div class="cartIconWrapper" @click="showCart" id="componentCartIcon">
                    <i class="iconfont icon-home-cart" />
                    <div class="label">购物车</div>
                    <div class="prodNumber">{{ cartProductTotalNumber }}</div>
                </div>
                <div class="totalPriceWrapper">
                    ￥{{ lodash.round(totalPrice, 2) }}
                </div>   
                <template
                    v-if="
                        shopInfo.minimallyBuyPrice <= totalPrice &&
                        shopInfo.ifBusiness == 0
                    "
                >
                    <div class="bottomButton"
                        @click="commitOrder"
                    >{{ commitOrderText }}</div>
                </template>
                <template v-else>
                    <div class="bottomButton"
                        disabled
                        @click="commitOrder"
                    >{{ commitOrderText }}</div>
                </template>
            </div>
        </div>


        <SharedIcon style="right: 0;bottom: 4em;" @click.native="showShopShareView" />
    </div>
</template>

<script>
//
import { mapState, mapGetters } from 'vuex'

//
import ProductOfShop from '@/components/shop/ProductOfShop.vue'
import Comment from '@/components/shop/Comment.vue'
import ShopInfo from '@/components/shop/ShopInfo.vue'
import SearchIcon from '#/common_components/SearchIcon.vue'
import BriefShopInfo from '@/components/shop/BriefShopInfo.vue'
import ProductOfListBrief from '@/components/shop/ProductOfListBrief.vue'
import HeaderAddress from '#/common_components/header/HeaderAddress.vue'

//
import ShopShare from '@/components/shop/ShopShare.vue'

//
import BaseFullScreenAnimation from '#/base_components/BaseFullScreenAnimation.vue'
import CurrentAddressTip from '#/common_components/customerAddress/CurrentAddressTip.vue'
import BuyNowButton from "#/common_components/BuyNowButton.vue";

//
import SharedIcon from '#/common_components/SharedIcon.vue'

//
import ShopCart from '@/components/cart/ShopCart.vue'
import ShopCartV2 from '@/components/cart/ShopCartV2.vue'

//
import { TRANSPORTATION_MODE_OUTSIDE_FENCING } from '#/utils/constants'

//
import { setShopProductList, getShopProductList, setShopState, getShopState  } from '@/storage/shop.js'

import {
    fetchGeoFencer
} from "#/utils/geo.js";

let loadMoreTime = 0;

export default {
    name: 'Shop',

    components: {
        BriefShopInfo,
        ProductOfShop,
        Comment,
        ShopInfo,
        SearchIcon,
        SharedIcon,
        CurrentAddressTip,
        ProductOfListBrief,
        HeaderAddress,
        BaseFullScreenAnimation,
        BuyNowButton,
    },

    props: {
        shopId: {
            type: Number,
            default: -1,
        },

        productId: {
            type: Number,
            default: -1,
        },
    },

    data() {
        return {
            ifShowTop: true,
            topContentInitHeight: 0,

            searchContent: '',

            activeCompositionContentTab: 'productAll',
            activeProductTypeIndex: 0,
            ifClickProductTypeSidebarScrollProceeding: false,

            category: [],
            mapIndexAsValueCategroyIdAsKey: {},

            ifShowAllProductList: true,
            productList: [],
            productListNeedShowWithCagetoryId: [],
            mapProductListAsValueCategoryIdAsKey: {},

            interestedProductInfo: null,

            productListWithTagAllCurrentPage: 0,
            productListWithTagAll: [],

            commentList: {
                currentPage: 0,
                totalPage: 0,
                records: [],
            },
            
            //
            totalPrice: 0,
            cartProductTotalNumber: 0,

            //
            TRANSPORTATION_MODE_OUTSIDE_FENCING:
                TRANSPORTATION_MODE_OUTSIDE_FENCING,

            //
            ifShowHeaderWarning: false,

            //
            contentCompositionProductAllScrollTop: 0,
            contentCompositionProductAllTypeScrollTop: 0,
            contentCompositionProductTypeScrollTop: 0,
            contentCompositionProductListScrollTop: 0,

            //
            cartCategoryProductList: [],

            //
            setShopStateTimeout: null,
        }
    },

    created() {
        // 
        if(this.shopInfo)
        {
            document.title = '云商舟山-' + this.shopInfo.shopNickname;
        }

        //
        this.$store.dispatch('order/getShelfIdWithMaxBuyNum', {
            shopId: this.shopId,
        }, () => {
            if(this.shopId == 2275)
            {
                this.checkProuductNumAndTotalPriceV2();
            }
        });

        //
        this.$store.dispatch('cart/getCart', {
            shopId: this.shopId,
            forceUpdate: true,
            cb: (err) => {
                //
                if(!err && this.shopId == 2275)
                {
                    this.checkProuductNumAndTotalPriceV2();
                }
            }
        })

        //
        this.$store.dispatch('shop/getShopMsg', this.shopId, (err) => {
            //
            if(!err && this.shopId == 2275)
            {
                this.checkProuductNumAndTotalPriceV2();
            }
        });

        //
        this.$store.dispatch('shop/getShopInfoDetail', {
            shopId: this.shopId,
            cb: (err) => {
                //
                if(!err && this.shopId == 2275)
                {
                    this.checkProuductNumAndTotalPriceV2();
                }
            },
        })

        //
        this.getCategory(this.shopId, (err) => {
            if(!err && this.shopId == 2275)
            {
                this.checkProuductNumAndTotalPriceV2();
            }
        })

        //
        if (this.productId && this.productId != -1) {
            this.getInterestedProduct(this.productId)
        }

        //
        this.getCommentList(this.shopId, 1)

        //
        this.checkIfShowHeaderWarning()
    },

    mounted() {
        /**
         *
         */
        this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
            this.$refs.compositionContentTab.firstChild
                .children[0].offsetLeft +
            this.$refs.compositionContentTab.firstChild.children[0].getClientRects()[0]
                .width /
                2 -
            this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                .width /
                2
        }px`;
    },

    computed: {
        ...mapState({
            shopInfo: (state) => state.shop.shopInfo,
            userInfo: (state) => state.auth.userInfo,
            userAddress: (state) => state.address.address,
            cartInfoAll: (state) => state.cart.cartInfoAll,
            shopInfoDetail: (state) => state.shop.shopInfoDetail,
            defaultAddress: (state) => state.address.defaultAddress,
            keepAliveShop: (state) => state.keepAlive.keepAliveShop,
            shelfIdMapWithMaxBuyNum: state => {
                let shelfIdMapWithMaxBuyNumTmp = {};

                for(let item of state.order.shelfIdListWithMaxBuyNum)
                {
                    shelfIdMapWithMaxBuyNumTmp[item.id] = item;
                }

                return shelfIdMapWithMaxBuyNumTmp;
            },
        }),

        ...mapGetters('cart', ['getCartInfo']),

        productPurchaseTotalNumber()
        {
            let tmp = 0;

            for(let typeId in this.productTypeStatistic)
            {
                tmp += parseInt(this.productTypeStatistic[typeId]);
            }

            return tmp;
        },

        cartInfo() {
            if (this.cartInfoAll && process.env.NODE_ENV == 'development') {
                console.log('shop, cartInfoAll changed')
            }

            //
            return this.getCartInfo(this.shopId)
        },

        productTypeStatistic() {
            //
            let tmp = {}

            //
            for (let { shelfId, snum } of this.cartInfo.shoppingCars) {
                //
                if (shelfId == null) {
                    continue
                }

                //
                for (let categoryId of shelfId) {
                    if (tmp[categoryId] == null) {
                        tmp[categoryId] = 0
                    }

                    //
                    tmp[categoryId] += snum
                }
            }

            //
            return tmp
        },

        commitOrderText() {
            if (this.shopInfo.ifBusiness == 1) {
                return '店铺已暂停营业'
            }

            if(this.shopId == 2275)
            {
                if(this.totalPrice < this.shopInfo.minimallyBuyPrice)
                {
                    return `差${this.lodash.round(
                        this.shopInfo.minimallyBuyPrice - this.totalPrice,
                        2
                    )}元起送`
                }

                for(let item of this.cartCategoryProductList)
                {
                    if(item.yingqiyu_warning)
                    {
                        return `${item.yingqiyu_categoryName} ${item.yingqiyu_warning}`
                    }
                }

                return '立即结算';
            }
            else
            {
                return this.totalPrice >= this.shopInfo.minimallyBuyPrice
                ? '立即结算'
                : `差${this.lodash.round(
                      this.shopInfo.minimallyBuyPrice - this.totalPrice,
                      2
                  )}元起送`
            }
            
        },

        bottomBarDescription() {
            return `店铺营业时间为 ${
                this.shopInfo.openTime
            } 到 ${this.shopInfo.offTime} ${
                this.shopInfo.ifShopOpen ? '' : ', 现已关门, 提交订单次日达'
            }`
        },
    },

    watch: {
        shopInfo()
        {
            document.title = '云商舟山-' + this.shopInfo.shopNickname;
        },

        defaultAddress() {
            this.checkIfShowHeaderWarning()
        },

        cartInfo(newVal) {
            if(this.shopId == 2275)
            {
                this.checkProuductNumAndTotalPriceV2();
            }
            else
            {
                this.checkProuductNumAndTotalPrice();
            }
        },

        ifShowTop()
        {
            if(this.topContentInitHeight == 0)
            {
                this.topContentInitHeight = this.$refs.topContent.clientHeight;

                //
                this.$refs.topContent.style.height = `${this.topContentInitHeight}px`;

                //
                setTimeout(() => {
                    if(this.ifShowTop == true)
                    {
                        this.$refs.topContent.style.height = `${this.topContentInitHeight}px`;
                    }
                    else
                    {
                        //
                        this.$refs.topContent.style.height = '0';  
                    }
                }, 50);

                return;
            }

            if(this.ifShowTop == true)
            {
                this.$refs.topContent.style.height = `${this.topContentInitHeight}px`;
            }
            else
            {
                //
                this.$refs.topContent.style.height = '0';  
            }
        },
    },

    methods: {
        productAllSwipeLeft()
        {
            if(this.category.length == 0 || this.activeProductTypeIndex == this.category.length - 1)
            {
                return this.Toast("已经滑到底了");
            }
            if(this.ifShowAllProductList == true)
            {
                this.ifShowAllProductList = false;

                this.clickProductTypeSidebar(0);
            }
            else
            {
                this.clickProductTypeSidebar(this.activeProductTypeIndex + 1);
            }
        },
        
        productAllSwipeRight()
        {
            if(this.ifShowAllProductList == true)
            {
                return this.Toast("已经滑到头了");
            }
            else if(this.activeProductTypeIndex == 0)
            {
                this.showAllProduct();
            }
            else
            {
                this.clickProductTypeSidebar(this.activeProductTypeIndex - 1);
            }
        },

        swipeUp()
        {
            this.ifShowTop = false;

            //
            setShopState(this.shopId, {
                ifShowTop: false,
                ifShowAllProductList: this.ifShowAllProductList,
                activeProductTypeIndex: this.activeProductTypeIndex,
                productListWithTagAll: this.productListWithTagAll, 
                scrollTop: this.contentCompositionProductAllScrollTop,
            });
        },

        swipeDown()
        {
            if(this.activeCompositionContentTab == 'productAll' && this.contentCompositionProductAllScrollTop < 50)
            {
                this.ifShowTop = true;
            }
            else if(this.activeCompositionContentTab == 'productCategory' && this.contentCompositionProductListScrollTop < 50)
            {
                this.ifShowTop = true;
            }
            else if(this.activeCompositionContentTab == 'comment' || this.activeCompositionContentTab == 'shop')
            {
                this.ifShowTop = true;
            }

            //
            setShopState(this.shopId, {
                ifShowTop: this.ifShowTop,
                ifShowAllProductList: this.ifShowAllProductList,
                activeProductTypeIndex: this.activeProductTypeIndex,
                productListWithTagAll: this.productListWithTagAll, 
                scrollTop: this.contentCompositionProductAllScrollTop,
            });
        },

        /**
         * 
         */
        showAllProduct()
        {
            this.ifShowTop = false;

            //
            this.ifShowAllProductList = true;

            //
            this.$refs.productAllTypeBottomLine.style.width = this.$refs.productAllSideType_all.clientWidth + "px";
            this.$refs.productAllTypeBottomLine.style.marginLeft = this.$refs.productAllSideType_all.offsetLeft + "px";
            
            //
            this.$refs.productAllSideType_all.scrollIntoView({
                inline: 'center',
            });

            //
            this.productListWithTagAllCurrentPage = 0;
            this.productListWithTagAll = this.productList.slice(this.productListWithTagAllCurrentPage * 30, this.productListWithTagAllCurrentPage * 30 + 30);
        
            //
            setShopState(this.shopId, {
                ifShowTop: false,
                ifShowAllProductList: this.ifShowAllProductList,
                activeProductTypeIndex: this.activeProductTypeIndex,
                productListWithTagAll: this.productListWithTagAll, 
                scrollTop: 0,
            });
        },

        contactCustomerService()
        {
            window.location.href = "https://work.weixin.qq.com/kfid/kfc28402346acfef5ee";
        },

        goToMainPage()
        {
            window.location.href = "https://shop.ziubao.com/main_static";
        },

        goToMine()
        {
            this.$router.push({
                path: "/mine"
            });
        },

        showCart() {
            if(this.shopId == 2275)
            {
                this.createComponent(ShopCartV2, {
                    props: {
                        shopId: this.shopId,
                    }
                });
            }
            else
            {
                this.createComponent(ShopCart, {
                    props: {
                        shopId: this.shopId,
                    }
                });
            }
        },

        checkProuductNumAndTotalPrice() {
            this.cartProductTotalNumber = this.cartInfo.shoppingCars.length

            /**
             *
             */
            this.totalPrice = 0

            //
            for (let { productInfo, snum } of this.cartInfo.shoppingCars) {
                //
                this.totalPrice += productInfo.pNowPrice * snum
            }
        },

        checkProuductNumAndTotalPriceV2() {
            if(this.cartInfo.shoppingCars == null)
            {
                return;
            }

            if(this.shopInfo == null || this.shopInfo.minimallyBuyPrice == null)
            {
                return;
            }

            if(this.$store.state.order.shelfIdListWithMaxBuyNum == null)
            {
                return;
            }

            this.cartProductTotalNumber = this.cartInfo.shoppingCars.length;

            /**
             * 
             */
            this.totalPrice = 0;
            this.cartCategoryProductList = JSON.parse(JSON.stringify(this.cartInfo.shoppingCars));
            let preCategoryId = null;
            let firstCategoryProduct = null;
            this.cartCategoryProductList.forEach(el => {
                //
                el.yingqiyu_categoryName = null;
                el.yingqiyu_categoryTotalPrice = null;
                el.yingqiyu_warning = null;

                /**
                 * 
                 */
                if(el.shelfId[0] != preCategoryId)
                {
                    /**
                     * 
                     */
                    if(firstCategoryProduct)
                    {
                        if(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice == "")
                        {
                            this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = this.shopInfo.minimallyBuyPrice;
                        }
                        else
                        {
                            this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = parseInt(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice);
                        }

                        if(firstCategoryProduct.yingqiyu_categoryTotalPrice < this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice)
                        {
                            firstCategoryProduct.yingqiyu_warning = `差${this.lodash.round(
                                this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice - firstCategoryProduct.yingqiyu_categoryTotalPrice,
                                2
                            )}元起送`;
                        }
                    }

                    /**
                     * 
                     */
                    el.yingqiyu_categoryName = this.shelfIdMapWithMaxBuyNum[el.shelfId[0]].shelfName;
                    el.yingqiyu_categoryTotalPrice = 0;

                    //
                    firstCategoryProduct = el;

                    //
                    preCategoryId = el.shelfId[0];
                }

                firstCategoryProduct.yingqiyu_categoryTotalPrice += el.productInfo.pNowPrice * el.snum;
                this.totalPrice += el.productInfo.pNowPrice * el.snum;
            });

            //
            if(firstCategoryProduct)
            {
                if(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice == "")
                {
                    this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = this.shopInfo.minimallyBuyPrice;
                }
                else
                {
                    this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = parseInt(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice);
                }

                if(firstCategoryProduct.yingqiyu_categoryTotalPrice < this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice)
                {
                    firstCategoryProduct.yingqiyu_warning = `差${this.lodash.round(
                        this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice - firstCategoryProduct.yingqiyu_categoryTotalPrice,
                        2
                    )}元起送`;
                }
            }
        },

        showShopShareView() {
            //
            this.createComponent(ShopShare, {
                props: {
                    shopName: this.shopInfoDetail.shopName,
                },
            })
        },

        checkIfShowHeaderWarning() {
            if (this.defaultAddress == null) {
                this.ifShowHeaderWarning = false

                //
                return
            }

            //
            if (this.defaultAddress.aId != null) {
                this.ifShowHeaderWarning =
                    this.defaultAddress &&
                    this.defaultAddress.transportationMode ==
                        TRANSPORTATION_MODE_OUTSIDE_FENCING

                //
                return
            }
            else
            {
                (async () => {
                    const innerList = await fetchGeoFencer(this.shopId);
                    const mixedFencer = turf.polygon(innerList);

                    //
                    this.ifShowHeaderWarning = !turf.booleanPointInPolygon(turf.point([this.defaultAddress.lng, this.defaultAddress.lat]), mixedFencer)
                })();
                
                //
                return;
            }

            //
            (async () => {
                try {
                    const { statusCode, data, msg } = await this.axios.shop.get(
                        '/newShop/getDistributionMsg.do',
                        {
                            longitute: this.defaultAddress.lng,
                            lantitute: this.defaultAddress.lat,
                            shopId: this.shopId,
                        }
                    )

                    //
                    if (statusCode != '200') {
                        return this.Toast(`获取支持的配送信息出错, ${msg}`)
                    }

                    //
                    let addressTransportationInfo =
                        this.address_pb.AddressTransportationInfo.deserializeBinary(
                            data
                        )

                    //
                    const transportationMode =
                        addressTransportationInfo.getTransportationMode()

                    //
                    this.ifShowHeaderWarning =
                        transportationMode ==
                        TRANSPORTATION_MODE_OUTSIDE_FENCING
                } catch (error) {
                    //
                    this.Toast(`获取支持的配送信息出错, ${error.toString()}`)
                }
            })()
        },

        /**
         * composition content tab click
         */
        clickActiveCompositionContentTab(type) {
            this.ifShowTop = false;

            //
            this.activeCompositionContentTabChange(type);

            //
            setShopState(this.shopId, {
                ifShowTop: false,
                ifShowAllProductList: this.ifShowAllProductList,
                activeProductTypeIndex: this.activeProductTypeIndex,
                productListWithTagAll: this.productListWithTagAll, 
                scrollTop: this.contentCompositionProductAllScrollTop,
            });
        },

        activeCompositionContentTabChange(type)
        {
            if(false)
            {
                if (type == 'productAll') {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[0].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[0].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                } else if (type == 'productCategory') {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[1].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[1].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`

                    /**
                     * 
                     */
                    this.$nextTick(() => {
                        const categoryId = this.category[this.activeProductTypeIndex].productTypeId

                        //
                        if (
                            this.mapProductListAsValueCategoryIdAsKey[categoryId] == null ||
                            this.mapProductListAsValueCategoryIdAsKey[categoryId].length == 0
                        ) {
                            //
                            return this.Toast('当前分类下不存在商品')
                        }

                        /**
                         * scroll to specified product
                         */
                        this.ifClickProductTypeSidebarScrollProceeding = true;

                        //
                        const { pId, currentCategory } =
                            this.mapProductListAsValueCategoryIdAsKey[categoryId][0];

                        //
                        const item =
                            this.$refs[`ProductOfShop-${pId}-${currentCategory}`][0];

                        //
                        item.scrollIntoView({
                            block: 'start',
                            inline: 'nearest',
                        });

                        //
                        this.$nextTick(() => {
                            this.ifClickProductTypeSidebarScrollProceeding = false;
                        });
                    });
                } else if (type == 'comment') {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[2].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[2].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                } else {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[3].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[3].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                }

                //
                this.activeCompositionContentTab = type;
            }
            else
            {
                if (type == 'productAll') {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[0].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[0].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                } else if (type == 'comment') {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[1].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[1].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                } else {
                    /**
                     *
                     */
                    this.$refs.stickyCompositionContentTabBottomLine.style.marginLeft = `${
                        this.$refs.compositionContentTab.firstChild
                            .children[2].offsetLeft +
                        this.$refs.compositionContentTab.firstChild.children[2].getClientRects()[0]
                            .width /
                            2 -
                        this.$refs.stickyCompositionContentTabBottomLine.getClientRects()[0]
                            .width /
                            2
                    }px`
                }

                //
                this.activeCompositionContentTab = type;
            }
        },

        /**
         * product category click
         */
        async clickProductTypeSidebar(index) {
            this.ifShowTop = false;

            /**
             * locate first product of this category
             */
            const categoryId =
                this.category[index].productTypeId

            //
            if (
                this.mapProductListAsValueCategoryIdAsKey[categoryId] == null ||
                this.mapProductListAsValueCategoryIdAsKey[categoryId].length == 0
            ) {
                //
                return this.Toast('当前分类下不存在商品')
            }

            //
            this.ifClickProductTypeSidebarScrollProceeding = true;

            //
            this.activeProductTypeIndex = index;

            /**
             * scroll to specified product
             */
            if(this.activeCompositionContentTab == 'productCategory')
            {

                //
                const { pId, currentCategory } =
                    this.mapProductListAsValueCategoryIdAsKey[categoryId][0];

                //
                const item =
                    this.$refs[`ProductOfShop-${pId}-${currentCategory}`][0];

                //
                item.scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                })
            }
            
            /**
             * scroll to top and change productType underline
             */
            else if(this.activeCompositionContentTab == 'productAll')
            {
                this.$refs.contentCompositionProductAllScroll.$el.scrollTo({
                    top: 0,
                });

                //
                this.ifShowAllProductList = false;

                //
                this.$refs.productAllTypeBottomLine.style.width = this.$refs[`productAllSideType_${index}`][0].clientWidth + "px";
                this.$refs.productAllTypeBottomLine.style.marginLeft = this.$refs[`productAllSideType_${index}`][0].offsetLeft + "px";
            
                //
                this.$refs[`productAllSideType_${index}`][0].scrollIntoView({
                    inline: 'center',
                });

                //
                setTimeout(() => {
                    this.productListWithTagAllCurrentPage = 0;
                    this.productListWithTagAll = this.productList.filter(el => {
                        return this.ifShowAllProductList == true || this.lodash.uniq(
                            el.shelfIdList
                        ).indexOf(this.category[this.activeProductTypeIndex].productTypeId) >= 0
                    }).slice(this.productListWithTagAllCurrentPage * 30, this.productListWithTagAllCurrentPage * 30 + 30);

                    //
                    setShopState(this.shopId, {
                        ifShowTop: false,
                        ifShowAllProductList: this.ifShowAllProductList,
                        activeProductTypeIndex: this.activeProductTypeIndex,
                        productListWithTagAll: this.productListWithTagAll, 
                        scrollTop: 0,
                    });
                }, 50);
            }

            //
            this.$nextTick(() => {
                this.ifClickProductTypeSidebarScrollProceeding = false;
            });
        },

        /**
         * scroll control
         */
        productListAllTypeScrollTop(scrollTop, direction)
        {
            this.contentCompositionProductAllScrollTop = scrollTop;
        },

        productListAllScrollTop(scrollTop, direction)
        {
            this.contentCompositionProductAllScrollTop = scrollTop;

            // if(direction == 'down' && scrollTop < 100)
            // {
            //     this.ifShowTop = true;
            // }
            // else if(direction == 'up' && scrollTop > 100)
            // {
            //     this.ifShowTop = false;
            // }

            const marginBottom = this.$refs.contentCompositionProductAllScroll.$el.scrollHeight - this.$refs.contentCompositionProductAllScroll.$el.getClientRects()[0].height - scrollTop;

            //
            if(direction == 'up' && marginBottom < 20 && Date.now() - loadMoreTime > 1000)
            {
                if(this.productListWithTagAll.length >= this.productList.length)
                {
                    return;
                }

                loadMoreTime = Date.now();

                this.productListWithTagAllCurrentPage ++;

                const productListAdd = this.productList.filter(el => {
                    return this.ifShowAllProductList == true || this.lodash.uniq(
                        el.shelfIdList
                    ).indexOf(this.category[this.activeProductTypeIndex].productTypeId) >= 0
                }).slice(this.productListWithTagAllCurrentPage * 30, this.productListWithTagAllCurrentPage * 30 + 30)
            
                for(let el of productListAdd)
                {
                    this.productListWithTagAll.push(el);
                }
            }

            //
            if(this.setShopStateTimeout)
            {
                clearInterval(this.setShopStateTimeout);

                //
                this.setShopStateTimeout = null;
            }

            //
            this.setShopStateTimeout = setTimeout(() => {
                setShopState(this.shopId, {
                    ifShowTop: this.ifShowTop,
                    ifShowAllProductList: this.ifShowAllProductList,
                    activeProductTypeIndex: this.activeProductTypeIndex,
                    productListWithTagAll: this.productListWithTagAll, 
                    scrollTop: this.contentCompositionProductAllScrollTop,
                });
            }, 100);
        },

        productCategoryScrollTop(scrollTop, direction)
        {
            this.contentCompositionProductTypeScrollTop = scrollTop;

            // if(direction == 'down' && scrollTop < 100)
            // {
            //     this.ifShowTop = true;
            // }
            // else if(direction == 'up' && scrollTop > 100)
            // {
            //     this.ifShowTop = false;
            // }
        },

        productListScrollTop(scrollTop, direction) {
            this.contentCompositionProductListScrollTop = scrollTop;

            // if(direction == 'down' && scrollTop < 100)
            // {
            //     this.ifShowTop = true;
            // }
            // else if(direction == 'up' && scrollTop > 100)
            // {
            //     this.ifShowTop = false;
            // }
            
            //
            if(this.ifClickProductTypeSidebarScrollProceeding)
            {
                return;
            }

            /**
             * calculate product view height
             */
            let firstProductOfShop = document.getElementById(
                'productOfShopIndex_0'
            )
            let productOfShopHeight = 0
            if (firstProductOfShop) {
                productOfShopHeight =
                    firstProductOfShop.getClientRects()[0].height
            }
            else
            {
                return;
            }

            /**
             * estimate product tab by calculate product list position
             */
            if (this.productId && this.productId != -1) {
                scrollTop -= productOfShopHeight
            }

            // notice, when scroll up, index base on bottom product element
            if (direction == 'up') {
                scrollTop +=
                    this.$refs.contentCompositionWrapper.getClientRects()[0]
                        .height
            }

            //
            let index = parseInt(scrollTop / productOfShopHeight)

            //
            if (index >= 0 && this.productListNeedShowWithCagetoryId[index]) {
                //
                let { currentCategory } = this.productListNeedShowWithCagetoryId[index]

                //
                if (this.mapIndexAsValueCategroyIdAsKey[currentCategory] != null) {
                    this.activeProductTypeIndex =
                        this.mapIndexAsValueCategroyIdAsKey[currentCategory]
                }
            }
        },

        /**
         * loading more comment list
         */
        commentListPullingUp() {
            if (this.activeCompositionContentTab == 'comment') {
                this.getCommentList(
                    this.shopId,
                    this.commentList.currentPage + 1
                )
            }
        },

        /**
         * fetch data
         */
        getCategory(shopId, cb) {
            this.axios.shop
                .get('/shophome/getShopType.do', {
                    shopId: shopId,
                })
                .then(({ statusCode, msg, data }) => {
                    if (statusCode !== '200') {
                        return this.Toast(`获取商品分类失败, ${msg}`)
                    }

                    //
                    this.category = data;

                    //
                    for (let index = 0; index < this.category.length; index++) {
                        let item = this.category[index];

                        //
                        this.mapIndexAsValueCategroyIdAsKey[item.productTypeId] =
                            index;
                    }
                    
                    //
                    this.getProductList(this.shopId)

                    if(cb)
                    {
                        cb()
                    }
                })
                .catch((e) => {
                    this.Toast(e.toString())

                    if(cb)
                    {
                        cb(e)
                    }
                })
        },

        getProductList(shopId) {
            //
            this.axios.shop
                .get('/newShop/getAllProducts.do', {
                    shopId: shopId,
                })
                .then(({ statusCode, msg, data }) => {
                    if (statusCode !== '200') {
                        return this.Toast(`获取商品列表失败, ${msg}`)
                    }

                    //
                    try
                    {
                        let productList =
                        this.shop_pb.ProductList.deserializeBinary(data)

                        //
                        this.productList = productList.toObject().productInfoList
                    }
                    catch(e) {

                    }

                    // put interested product at first place
                    if (this.productId && this.productId != -1) {
                        //
                        for(let i = 0; i < this.productList.length; i ++)
                        {
                            if(this.productList[i].pId == this.productId)
                            {
                                //
                                let tmp = this.productList[0];
                                this.productList[0] = this.productList[i];
                                this.productList[i] = tmp;

                                //
                                break;
                            }
                        }
                    }

                    //
                    this.productListWithTagAllCurrentPage = 0;
                    this.productListWithTagAll = this.productList.slice(this.productListWithTagAllCurrentPage * 30, this.productListWithTagAllCurrentPage * 30 + 30)

                    //
                    if (false && process.env.NODE_ENV == 'development') {
                        console.log(
                            `productList: ${JSON.stringify(this.productList)}`
                        )
                    }

                    /**
                     *
                     */
                    for (let item of this.productList) {
                        if (!item.shelfIdList) {
                            continue
                        }

                        //
                        for (let productCategory of this.lodash.uniq(
                            item.shelfIdList
                        )) {
                            /**
                             *
                             */
                            if (
                                !this.mapProductListAsValueCategoryIdAsKey[productCategory]
                            ) {
                                this.mapProductListAsValueCategoryIdAsKey[productCategory] =
                                    []
                            }

                            //
                            let newProductItem = Object.assign(
                                {
                                    currentCategory: productCategory,
                                },
                                item
                            )

                            //
                            this.mapProductListAsValueCategoryIdAsKey[productCategory].push(
                                newProductItem
                            );
                        }
                    }

                    //
                    let productListTmp = []

                    for (let { productTypeId } of this.category) {
                        for (let product of this.mapProductListAsValueCategoryIdAsKey[
                            productTypeId
                        ] || []) {
                            //
                            productListTmp.push(product)
                        }
                    }
                    this.productListNeedShowWithCagetoryId = productListTmp

                    //
                    setShopProductList(
                        this.shopId,
                        JSON.stringify(this.productListNeedShowWithCagetoryId)
                    )

                    if(false)
                    {
                        //
                        let activeTab = null
                        if (
                            this.keepAliveShop
                                .activeCompositionContentTab != ''
                        ) {
                            activeTab =
                                this.keepAliveShop
                                    .activeCompositionContentTab
                        } else {
                            activeTab = 'productAll'
                        }

                        this.activeCompositionContentTabChange(activeTab)

                        //
                        this.recoverPageState()
                    }
                })
                .catch((e) => {
                    this.Toast(e.toString())
                })
                .finally(() => {
                    //
                    const baseFullScreenAnimationDom = this.$refs.baseFullScreenAnimation.$el.parentElement;
                    var parent = baseFullScreenAnimationDom.parentElement;
                    parent.removeChild(baseFullScreenAnimationDom);

                    //
                    const shopState = getShopState(this.shopId);
                    
                    //
                    this.ifShowTop = shopState.ifShowTop;
                    this.ifShowAllProductList = shopState.ifShowAllProductList;
                    this.activeProductTypeIndex = shopState.activeProductTypeIndex;
                    
                    //
                    if(!this.ifShowAllProductList)
                    {
                        setTimeout(() => {                        
                            this.$refs.productAllTypeBottomLine.style.width = this.$refs[`productAllSideType_${this.activeProductTypeIndex}`][0].clientWidth + "px";
                            this.$refs.productAllTypeBottomLine.style.marginLeft = this.$refs[`productAllSideType_${this.activeProductTypeIndex}`][0].offsetLeft + "px";

                            //
                            this.$refs[`productAllSideType_${this.activeProductTypeIndex}`][0].scrollIntoView({
                                inline: 'center',
                            });
                        }, 100);
                    }

                    //
                    if(!this.ifShowTop)
                    {
                        //
                        this.productListWithTagAll = shopState.productListWithTagAll;  

                        //
                        setTimeout(() => {
                            //
                            this.$refs.contentCompositionProductAllScroll.$el.scrollTo({
                                top: shopState.scrollTop,
                            });
                        }, 100);
                    }
                })
        },


        getInterestedProduct(productId) {
            //
            this.axios.shop
                .get('/nproductController/getProductById.do', {
                    pId: productId,
                })
                .then(({ statusCode, msg, data }) => {
                    if (statusCode !== '200') {
                        return this.Toast(`获取关注的商品信息失败, ${msg}`)
                    }

                    //
                    this.interestedProductInfo = data
                })
                .catch((e) => {
                    this.Toast(e.toString())
                })
        },

        getCommentList(shopId, currentPage) {
            // page check
            if (currentPage > 1 && currentPage > this.commentList.totalPage) {
                return this.Toast('没有更多评论了')
            }

            //
            this.axios.shop
                .get('/shophome/getEvaluation.do', {
                    shopId,
                    current: currentPage,
                })
                .then(({ statusCode, msg, data }) => {
                    if (statusCode !== '200') {
                        return this.Toast(`获取评价列表失败, ${msg}`)
                    }

                    if (this.commentList.currentPage >= currentPage) {
                        return
                    }

                    //
                    this.commentList.currentPage = currentPage
                    this.commentList.totalPage = data.pages

                    //
                    if (currentPage == 1) {
                        this.$set(this.commentList, 'records', data.records)
                    } else {
                        this.$set(
                            this.commentList,
                            'records',
                            this.lodash.unionWith(
                                this.commentList.records,
                                data.records,
                                this.lodash.isEqual,
                            )
                        )
                    }
                })
                .catch((e) => {
                    this.Toast(e.toString())
                })
        },

        /**
         *
         */
        commitOrder() {
            if(this.shopId == 2275)
            {
                for(let item of this.cartCategoryProductList)
                {
                    if(item.yingqiyu_warning)
                    {
                        return;
                    }
                }
            }

            if(this.shopInfo.minimallyBuyPrice > this.totalPrice)
            {
                return;
            }

            //
            this.payApiCommitOrder(
                this.shopId,
                this.cartInfo.shoppingCars,
                1
            )
        },
        
        async recoverPageState() {
            if (
                this.keepAliveShop.shopId == this.shopId &&
                this.keepAliveShop.productId == this.productId
            ) {
                // wait until page render finish
                await this.$nextTick()

                //
                this.contentCompositionProductAllScrollTop = this.keepAliveShop.contentCompositionProductAllScrollTop;
                this.contentCompositionProductAllTypeScrollTop = this.keepAliveShop.contentCompositionProductAllTypeScrollTop;
                this.contentCompositionProductTypeScrollTop =
                    this.keepAliveShop.contentCompositionProductTypeScrollTop
                this.contentCompositionProductListScrollTop =
                    this.keepAliveShop.contentCompositionProductListScrollTop

                //
                switch(this.activeCompositionContentTab)
                {
                    case "productAll":
                    {
                        this.$refs.contentCompositionProductAllTypeScroll.$el.scrollTo({
                            top: this.contentCompositionProductAllTypeScrollTop,
                        });

                        this.$refs.contentCompositionProductAllScroll.$el.scrollTo({
                            top: this.contentCompositionProductAllScrollTop,
                        });
                    }
                    break;
                    case "productCategory":
                    {
                        this.$refs.contentCompositionProductTypeScroll.$el.scrollTo({
                            top: this.contentCompositionProductTypeScrollTop,
                        })
                        //
                        this.$refs.contentCompositionProductListScroll.$el.scrollTo({
                            top: this.contentCompositionProductListScrollTop,
                        })
                    }
                    break;
                }
            }
        },
    },

    /**
     *
     */
    beforeDestroy() {
        this.$store.commit('keepAlive/setKeepAliveShop', {
            shopType: 'shop',
            shopId: this.shopId,
            productId: this.productId,
            contentCompositionProductAllScrollTop: this.contentCompositionProductAllScrollTop,
            contentCompositionProductTypeScrollTop:
                this.contentCompositionProductTypeScrollTop,
            contentCompositionProductListScrollTop:
                this.contentCompositionProductListScrollTop,
            activeCompositionContentTab: this.activeCompositionContentTab,
        })
    },
}
</script>

<style lang="scss" scoped>
//
.shopMain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-size: $fontSizeContent;
    line-height: 2em;
    background-color: $neutralPageBackgroundColor;
}

//
.header {
    width: 100%;
    background: $headerBgColor;
    flex-shrink: 0;
}

.searchIconWrapperArch
{
    width: 100%;
    border-top-left-radius: $borderRadius;
    border-top-right-radius: $borderRadius;
    background-color: $neutralPageBackgroundColor;
}

.searchIconWrapper {
    width: 100%;
    box-sizing: border-box;
    padding: $padding;
}

//
.contentWrapper
{
    flex-grow: 1;
    overflow: hidden;
    box-sizing: border-box;
    padding: $padding;
    display: flex;
    flex-direction: column;
    
    .topContent {
        flex-shrink: 0;
        overflow: hidden;
        transition: all 1s;
    }
}

//
.warningAndshopDescription
{
    flex-shrink: 0;
}

.headerWarning {
    width: 100%;
    background: #99999930;
    color: red;
    font-size: 1.5em;
    line-height: 2em;
    font-weight: 800;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $borderRadius;
    flex-shrink: 0;
}

//
.compositionContentTab {
    margin-top: $margin;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    white-space: normal;
    background: #ffffff;
    border-radius: $borderRadius;
    flex-shrink: 0;
}

.stickyCompositionContentTabBottomLine {
    position: absolute;
    bottom: 0px;
    left: 0;
    z-index: 1;
    width: 0.4rem;
    height: 0.03rem;
    background-color: $primaryColor;
    border-radius: $borderRadius;
    transition: all 0.3s;
}

//
.contentCompositionWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    flex-grow: 1;
}

//
.contentCompositionProductAllWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    font-size: 0;
    display: flex;
    flex-direction: column;

    .categoryItemList
    {
        flex-shrink: 0;
        margin-bottom: 0.8em;

        .categoryItem
        {
            box-sizing: border-box;
            padding: 0 0.8em;
            line-height: 2.4em;
            display: inline-block;

            .title
            {
                margin-right: 0.4em;
                display: inline-block;
            }

            .number
            {
                color: $primaryColor;
                display: inline-block;
                font-weight: 800;
            }
        }

        .categoryItemActive
        {
            @extend .categoryItem;

            background: #ffffff;
        }

        .productAllTypeBottomLine
        {
            background: $primaryColor;
            width: 4em;
            height: 0.2em;
            margin-left: 0.8em;
            transition: all 0.2s;
        }
    }
}

//
.contentCompositionProductCategoryWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
}

.contentCompositionProductTypeScroll {
    width: 6em;
    height: 100%;
    overflow-y: auto;
}

.contentCompositionProductListScroll {
    height: 100%;
    margin-left: $margin;
    width: calc(100% - 6em - #{$margin});
    overflow-y: auto;
}

//
.contentCompositionCommentWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #ffffff;
}

.commentNoData
{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

//
.contentCompositionShopWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #ffffff;
}

//
.productOfProductAll {
    width: calc(50% - #{$margin});
    display: inline-block;
    box-sizing: border-box;
}

.productOfProductAllLeft
{
    @extend .productOfProductAll;

    margin-right: $margin;
}

.productOfProductAllRight
{
    @extend .productOfProductAll;

    margin-left: $margin;
}

//
.bottomBar {
    width: 100%;
    background: #ffffff;
    flex-shrink: 0;

    //
    .autoHorizonScroll {
        background: #fff7cc;
        color: $functionalFontAlertColor;
    }

    .operatePanel
    {
        box-sizing: border-box;
        padding: 0.5em 0.4em 0.2em 0.4em;
        display: flex;
        align-items: center;
        color: $neutralFontWeakColor;

        .homeIconWrapper
        {
            line-height: 0;
            text-align: center;
            margin-right: 1em;
            
            i {
                font-size: 1.2em;
                line-height: 1em;
            }

            .label
            {
                font-size: 1em;
                line-height: 1.5em;
                white-space: nowrap;
                overflow: auto;
            }
        }
        
        .mineIconWrapper
        {
            line-height: 0;
            text-align: center;
            margin-right: 1em;

            i {
                font-size: 1.2em;
                line-height: 1em;
            }

            .label
            {
                font-size: 1em;
                line-height: 1.5em;
                white-space: nowrap;
                overflow: auto;
            }
        }

        .cartIconWrapper
        {
            line-height: 0;
            text-align: center;
            position: relative;

            i {
                font-size: 1.2em;
                line-height: 1em;
            }

            .label
            {
                font-size: 1em;
                line-height: 1.5em;
                white-space: nowrap;
                overflow: auto;
            }

            .prodNumber {
                font-size: 0.8em;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                right: -0.2em;
                top: -0.2em;
                width: 1.2em;
                height: 1.2em;
                background: $primaryColor;
                color: #ffffff;
                border-radius: 0.6em;
            }
        }

        .totalPriceWrapper
        {
            flex-shrink: 0;
            flex-grow: 1;
            color: $primaryColor;
            font-weight: 800;
            margin: 0 0.04rem;
            white-space: nowrap;
            overflow: auto;
        }

        .bottomButton
        {
            min-width: 0.8rem;
            border: 0;
            background-color: $primaryColor;
            color: #ffffff;
            white-space: wrap;
            font-size: 1em;
            line-height: 1.6em;
            border-radius: 1.25em;
            padding: 0.04rem 2.5em;
            text-align: center;
            white-space: nowrap;
            overflow: auto;
        }
    }
}
</style>